import { gql } from 'graphql-request';

import { TaskNanoID, TaskUUID } from '../tasksTypes';

export interface ContinueTaskQueryResponse {
  uuid: TaskUUID;
  nanoId: TaskNanoID;
}

export const CONTINUE_TASK_QUERY = gql`
  mutation ContinueTask($uuid: ID!) {
    continueTask(input: { uuid: $uuid }) {
      recordUuid
      recordNanoId
      status
      record {
        uuid
        nanoId
      }
      errors {
        fullMessages
      }
    }
  }
`;
